<header class="iot-platform-ui-header flex flex-wrap items-center">
  <button
    (click)="onToggleMenuClick()"
    [matTooltipClass]="'regular-tooltip'"
    [matTooltip]="'HEADER.TOGGLE_NAVIGATION_TOOLTIP' | translate"
    class="regular-round-button toggle-navigation-btn !flex !items-center mr-2"
    mat-icon-button
  >
    <mat-icon>menu</mat-icon>
  </button>
  @if (environment.envType === 'prod') {
    <img (click)="onLogoClick()" [src]="'assets/images/' + logoIconName() + '.png'" alt="" class="iot-platform-ui-header__logo" />
  } @else {
    <img
      [matTooltip]="('APP_NAME' | translate) + ' ' + environment.envName"
      matTooltipClass="regular-tooltip"
      (click)="onLogoClick()"
      [src]="'assets/images/' + logoIconName() + '-' + environment.envType + '.png'"
      alt=""
      class="iot-platform-ui-header__logo"
    />
  }
  <span class="hidden md:inline ml-3 border-right">{{ 'APP_NAME' | translate }}</span>
  <span class="hidden md:inline ml-5">{{ selectedProfile()?.entityName }}</span>
  <span class="flex-1"></span>
  @if(selectedProfile()?.timezoneDetails?.name) {
    <span class="hidden md:inline border-right">{{ timezone() }}</span>
  }@else if(selectedProfile()?.timezone) {
    <span class="hidden md:inline border-right">{{ selectedProfile()?.timezone }}</span>
  }

  <mat-select
    (click)="allowSwitchBusinessProfile() ? onBusinessProfileListClicked($event) : $event.preventDefault()"
    (selectionChange)="switchBusinessProfile($event)"
    [formControl]="selectedProfileControl"
    class="navbar-business-profile-select border-right ml-5"
  >
    <mat-select-trigger>{{ selectedProfile()?.name }}</mat-select-trigger>
    @for (profile of businessProfiles(); track profile.id) {
      <mat-option [disabled]="profile.notCoveredByUserEntityAt" [value]="profile">
        <span class="bp-list--bp-name">{{ profile.name }}</span>
        @if (profile.notCoveredByUserEntityAt) {
          <mat-icon [matTooltip]="'HEADER.BUSINESS_PROFILE_OUT_OF_SCOPE' | translate" class="bp-list--info-icon" matTooltipClass="regular-tooltip"
            >info_outlined
          </mat-icon>
        }
      </mat-option>
    }
  </mat-select>

  <button [matMenuTriggerFor]="menu" class="user-button ml-5" color="accent" mat-mini-fab>
    <p data-hj-suppress>{{ initials() }}</p>
  </button>
  @if (allowAIChatBot()) {
    <button
      (click)="chatBotClicked.emit()"
      [matTooltipClass]="'regular-tooltip'"
      [matTooltip]="'Ai Assistant' | translate"
      class="regular-round-button ml-2"
      mat-icon-button
    >
      <mat-icon>smart_toy</mat-icon>
    </button>
  }
  <mat-menu #menu="matMenu" class="flex flex-row">
    @if (allowRedirectToMyProfile()) {
      <button (click)="onMyProfileClick()" mat-menu-item>{{ 'HEADER.MY_PROFILE' | translate }}</button>
      <mat-divider></mat-divider>
    }
    <button (click)="onLogout()" mat-menu-item>{{ 'HEADER.LOGOUT' | translate }}</button>
  </mat-menu>
</header>
